import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomField } from 'on-shared/_models/CustomField';

@Component({
    selector: 'on-custom-field-ai-config-modal',
    templateUrl: './custom-field-ai-config-modal.component.html',
    styleUrls: ['./custom-field-ai-config-modal.component.scss'],
})
export class CustomFieldAiConfigModalComponent implements OnInit {
    @Input() customField: CustomField;

    aiRecognitionEnabled: boolean;
    aiRecognitionPrompt: string;
    maxPromptLength = 500;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit() {
        this.aiRecognitionEnabled = this.customField.IsAIRecognitionEnabled || false;
        this.aiRecognitionPrompt = this.customField.AIDescription || '';
    }

    get remainingCharacters(): number {
        return this.maxPromptLength - (this.aiRecognitionPrompt?.length || 0);
    }

    save() {
        this.customField.IsAIRecognitionEnabled = this.aiRecognitionEnabled;
        this.customField.AIDescription = this.aiRecognitionPrompt;
        this.activeModal.close(this.customField);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
